<template>
    <div class="order-price-label">
        <PricesWithCommission
            :order-prices="priceInSystemCurrency"
            :title="$t('price')"
            :is-show-v-a-t-commission="isShowVATCommission"
            :vat-calculated-amount-by-each-service-netto="vatCalculatedAmountByEachServiceNetto"
            :show-commission-and-netto-block="showCommissionAndNettoBlock"
        >
            <v-tooltip v-if="showConvertPrices" v-model="show" location="top" width="260">
                <template v-slot:activator="{props}">
                    <v-btn
                        v-bind="props"
                        size="small"
                        icon="mdi-cash-multiple"
                        variant="text"
                        density="compact"
                        color="grey"
                        class="mx-2 mb-2"
                        data-cy="show-currency-multiple"
                        @click="show = !show"
                    />
                </template>
                <PricesWithCommission
                    :order-prices="orderPrices"
                    :is-show-v-a-t-commission="isShowVATCommission"
                    :vat-calculated-amount-by-each-service-netto="vatCalculatedAmountByEachServiceNetto"
                    :show-commission-and-netto-block="showCommissionAndNettoBlock"
                />
            </v-tooltip>
        </PricesWithCommission>
        <v-row
            v-if="$conf.public.account.paymentScheduler"
            no-gutters
            class="commission-block align-center justify-space-between flex-wrap gc-4 gr-2"
        >
            <slot />
            <payment-status-label class="ml-auto" :status="paymentStatus" />
        </v-row>
        <!-- UI-24-1: sustainability rate breakdown for non-tour-operator viewers
             (agency / corporate / supplier / B2C). OrderDetailsSummary renders the
             price via <total-order-prices> for isTourOperator (TO1/TO2) and via
             <order-price-label> for everyone else. The TotalOrderPrices zsh override
             already injects the breakdown for the TO branch; this override covers the
             v-else branch so non-TO1 users also see the breakdown instead of just
             "Price: {value}". The component self-gates via its own v-if="breakdown". -->
        <SustainabilityPriceBreakdown :services="services" :order-prices="orderPrices" />
    </div>
</template>

<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import {OrderPriceLabel as _OrderPriceLabel} from '~src/components/account/snippets/OrderPriceLabel.vue'
    import PaymentStatusLabel from '~src/components/account/snippets/paymentStatusLabel.src'
    import PricesWithCommission from '~/components/account/snippets/PricesWithCommission.vue'
    import SustainabilityPriceBreakdown from '~/components/account/snippets/SustainabilityPriceBreakdown.vue'

    // UI-24-1: inject the sustainability price breakdown into the non-tour-operator
    // price label (the v-else branch of OrderDetailsSummary). Mixin-extends the core
    // class (inherits all props/getters) and provides a custom template that appends
    // <SustainabilityPriceBreakdown>. Mirrors the TotalOrderPrices zsh override; core
    // behavior unchanged for other builds (this override only exists in the zsh layer).
    @Component({components: {PricesWithCommission, PaymentStatusLabel, SustainabilityPriceBreakdown}})
    export class OrderPriceLabel extends _OrderPriceLabel {}

    export default {...toNative(OrderPriceLabel)}
</script>

<style lang="scss" scoped>
    @use 'vuetify/settings';
    @use 'sass:map';

    .v-tooltip :deep(.v-overlay__content) {
        background-color: white;
        color: black;
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.25);
    }
</style>
